<template>
  <SimpleDataWithVariation
    :title="title"
    :item-id="itemId"
    :value="value"
    :variation="variation"
    :raw-variation="rawVariation"
    :request-status="requestStatus"
    :comparation-value="comparationValue"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import { mapActions } from 'vuex';
import { formatSocialNumberWithDecimal } from '@/utils/formatter';
import { DATA_TYPE } from '@/store/modules/cards/constants';
import SimpleDataWithVariation from './models/SimpleDataWithVariation.vue';
import sacListeningModel from '@/mixins/sac-listening-model';

export default {
  name: 'OwnedEarnedPostReach',
  components: {
    SimpleDataWithVariation,
  },
  mixins: [
    sacListeningModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      showGlobalFilterModal: false,
      filterButton: this.$t('components.OperatorsLogs.filterLabel'),
      value: '',
      variation: '',
      rawVariation: '',
      comparationValue: '',
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getSacListeningWarroomService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }
      const promisses = [
        this.getSacListeningWarroomService({
          itemId: this.itemId,
          servicePath: 'monitoringOverview',
          filterType: DATA_TYPE.LISTENING,
        }),
        this.getSacListeningWarroomService({
          itemId: this.itemId,
          servicePath: 'monitoringOverview',
          filterType: DATA_TYPE.SAC,
        })];
      Promise.all(
        promisses
      ).then(([responseListening, responseSac]) => {
        this.value = responseListening.collected_mentions + responseSac.collected_mentions;
        this.variation = responseListening.collected_mentions_variation + responseSac.collected_mentions_variation;
        this.rawVariation = responseListening.collected_mentions_variation + responseSac.collected_mentions_variation;
        this.comparationValue = formatSocialNumberWithDecimal(responseListening.previous_collected_mentions + responseSac.previous_collected_mentions);
        this.requestStatus = 'success';
      });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
